const months = ['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember']
export function contextDate(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return '—'
  const date = new Date(`${value}T00:00:00Z`)
  if (Number.isNaN(date.getTime()) || date.toISOString().slice(0,10) !== value) return '—'
  return date.toLocaleDateString('id-ID', {day:'2-digit',month:'short',year:'numeric',timeZone:'UTC'})
}
export function contextPeriod(context) {
  if (!Number.isInteger(context?.accountingMonth) || !Number.isInteger(context?.accountingYear) || context.accountingMonth < 1 || context.accountingMonth > 12 || context.accountingYear < 1900) return '—'
  return `${months[context.accountingMonth-1]} ${context.accountingYear}`
}
export function lastClosedYear(context) {
  const year = Number(context?.calendarDate?.slice(0,4))
  return contextDate(context?.calendarDate) === '—' || year <= 1900 ? null : year-1
}
export function defaultCheckpointYear(context) {
  const closed = lastClosedYear(context)
  if (!closed) return null
  return Number.isInteger(context?.transactionYear) && context.transactionYear > 1900 ? Math.min(context.transactionYear-1,closed) : closed
}
